import { render, staticRenderFns } from "./CriteriaInput.vue?vue&type=template&id=39c150f5"
import script from "./CriteriaInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CriteriaInput.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CriteriaInput.vue?vue&type=style&index=0&id=39c150f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports